import React from 'react';
import { Button, Icon, Table, Form, Header, Segment, Popup, Loader, Input, Divider } from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';

import { IconHeader, FiltersOnStyle } from '../../../Professor/ProfessorInputGrades/css';
import StudyProgramsFilter from '../../StudentEnroll/StudyProgramsFilter';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


export default class Grades extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            semesterOptions: []
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.fetchMarkOptions = this.fetchMarkOptions.bind(this);
        this.fetchAcademicYearOptions = this.fetchAcademicYearOptions.bind(this);
        this.fetchSemesterOptions = this.fetchSemesterOptions.bind(this);
        this.fetchExamOptions = this.fetchExamOptions.bind(this);
        this.fetchStaffOptions = this.fetchStaffOptions.bind(this);
        this.fetchCourseImplementationOptions = this.fetchCourseImplementationOptions.bind(this);
        this.resetForm = this.resetForm.bind(this);
        this.addGrade = this.addGrade.bind(this);
    }

    componentDidMount() {
        this.props.fetchStudentOptions();
        this.fetchAcademicYearOptions();
        this.fetchMarkOptions();
    }
    fetchStaffOptions(examId) {
        axios.get(`/exams/staff/${examId}/`)
            .then(res => {
                this.setState({
                    staffOptions: res.data.map(el => ({
                        ...el, key: el.id, value: el.id, text: el.staff.employee.person.firstName + ' ' + el.staff.employee.person.lastName
                    }))
                });
            });
    }
    fetchExamOptions(courseImplementationId) {
        axios.get(`/exams/by-course-implementation/${courseImplementationId}/`)
            .then(res => {
                this.setState({
                    examOptions: res.data.map(el => ({
                        ...el, key: el.id, value: el.id, text: moment(el.date).format('D. M. YYYY.') + (el.type ? ' | ' + el.type.name : '')
                    }))
                });
            });
    }

    fetchMarkOptions() {
        axios.get('/marks')
            .then(res => {
                this.setState({
                    markOptions: res.data.map(el => ({
                        key: el.id, value: el.id, text: el.displayName
                    }))
                });
            });
    }

    fetchAcademicYearOptions() {
        // semester/by-academic-year/{academicYearId}
        axios.get('/academic-years/current-and-previous/')
            .then(res => {
                this.setState({
                    academicYearOptions: res.data.reverse().map(el => ({
                        ...el, key: el.id, value: el.id, text: el.name
                    }))
                });
            });
    }

    fetchSemesterOptions(academicYearId) {
        axios.get(`semester/by-academic-year/${academicYearId}`)
            .then(res => {
                this.setState({
                    semesterOptions: res.data.map(el => ({
                        ...el, key: el.id, value: el.name._key, text: el.name.name
                    }))
                });
            });
    }
    fetchCourseImplementationOptions(studentId, academicYearId, semesterKey) {
        let obj = {
            studentStudyProgramId: studentId,
            academicYearId,
            semesterKey
        };
        axios.post('/grade-student/ungraded/course-implementations/', { ...obj })
            .then(res => {
                this.setState({
                    courseImplementationOptions: res.data.map(el => ({
                        ...el, key: el.courseImplementationId, value: el.courseImplementationId, text: el.courseBasicName ? el.courseBasicName + ' | ' + el.code + (el.comment ? +' | ' + el.comment : '') : el.code + (el.comment ? +' | ' + el.comment : ''), description: el.courseBasicComment ? el.courseBasicComment : ''
                    }))
                });
            });
    }

    resetForm() {
        this.setState({

            mark: null,
            academicYear: null,
            semester: null,
            courseImplementation: null,
            exam: null,
            staff: null,

        });
    }

    addGrade() {
        if (!this.state.student || !this.state.semester || !this.state.academicYear || !this.state.courseImplementation
            || !this.state.exam || !this.state.mark) {
            toast(<FormattedMessage id="common.requiredFields" />);
            if (!this.state.student) { this.setState({ studentErr: true }); } else { this.setState({ studentErr: false }); }
            if (!this.state.semester) { this.setState({ semesterErr: true }); } else { this.setState({ semesterErr: false }); }
            if (!this.state.course) { this.setState({ courseErr: true }); } else { this.setState({ courseErr: false }); }
            if (!this.state.academicYear) { this.setState({ academicYearErr: true }); } else { this.setState({ academicYearErr: false }); }
            if (!this.state.courseImplementation) { this.setState({ courseImplementationErr: true }); } else { this.setState({ courseImplementationErr: false }); }
            if (!this.state.exam) { this.setState({ examErr: true }); } else { this.setState({ examErr: false }); }
            if (!this.state.mark) { this.setState({ markErr: true }); } else { this.setState({ markErr: false }); }
        } else {
            this.setState({ loader: true });
            let obj = {
                studentCourseImplementationId: this.state.courseImplementationOptions.find((e) => e.courseImplementationId === this.state.courseImplementation).studentCourseImplementationId,
                gradedActivityId: this.state.exam,
                markId: this.state.mark,
                staffGradedActivityId: this.state.staff
            };
            axios.post('/grade-student/third-cycle-or-specialist-study-program/', { ...obj }).then((res) => {
                toast('Uspješno ste ocijenili studenta!');
                this.setState({ loader: false });
                this.resetForm();
            }).catch(() => {
                this.setState({ loader: false });
                toast('Došlo je do greške! Studentu nije unešena ocjena.');
            });
        }
    }

    handleInputChange(event, { name, value }) {
        if (name === 'student' && this.state.academicYear && this.state.semester) { this.fetchCourseImplementationOptions(value.id, this.state.academicYear, this.state.semester); }
        if (name === 'academicYear') { this.fetchSemesterOptions(value); if (this.state.student && this.state.semester) { this.fetchCourseImplementationOptions(this.state.student.id, value, this.state.semester); } }
        if (name === 'semester' && this.state.academicYear && this.state.student) { this.fetchCourseImplementationOptions(this.state.student.id, this.state.academicYear, value); }
        if (name === 'courseImplementation') { this.fetchExamOptions(value); }
        if (name === 'exam') { this.fetchStaffOptions(value); }


        this.setState({
            [name]: value
        });
    }

    render() {
        return (
            <div>


                <Loader active={this.state.loader} />
                {/* <Divider horizontal> */}
                {/*    <Header as='h4'> */}
                {/*       Podaci o upisu */}
                {/*    </Header> */}
                {/* </Divider> */}

                <Form>
                    <Form.Group widths="equal">
                        <Form.Field required error={this.state.studentErr}>
                            <label>Student</label>
                            <Form.Dropdown
                                clearable
                                placeholder="Odabir studenta"
                                value={this.state.student}
                                onChange={this.handleInputChange}
                                name="student"
                                options={this.props.studentOptions}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>

                        <Form.Field required error={this.state.academicYearErr}>
                            <label>Akademska godina</label>
                            <Form.Dropdown
                                clearable
                                placeholder="Odabir godine"
                                value={this.state.academicYear}
                                onChange={this.handleInputChange}
                                name="academicYear"
                                options={this.state.academicYearOptions}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                        <Form.Field required error={this.state.semesterErr}>
                            <label>Semestar</label>
                            <Form.Dropdown
                                clearable
                                placeholder="Odabir semestra"
                                value={this.state.semester}
                                onChange={this.handleInputChange}
                                name="semester"
                                options={this.state.semesterOptions.filter(e => e.name._key !== 'other' && e.name._key !== 'summer school')}
                                search
                                disabled={!this.state.academicYear}
                                fluid
                                selection
                            />
                        </Form.Field>


                    </Form.Group>
                    <Form.Group widths="equal">

                        <Form.Field required error={this.state.courseImplementationErr}>
                            <label>Predmet </label>
                            <Form.Dropdown
                                clearable
                                placeholder="Odabir implementacije"
                                value={this.state.courseImplementation}
                                onChange={this.handleInputChange}
                                name="courseImplementation"
                                disabled={!this.state.student || !this.state.academicYear || !this.state.semester}
                                options={this.state.courseImplementationOptions}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>

                        <Form.Field required error={this.state.examErr}>
                            <label>Ispit </label>
                            <Form.Dropdown
                                clearable
                                placeholder="Odabir ispita"
                                value={this.state.exam}
                                onChange={this.handleInputChange}
                                name="exam"
                                disabled={!this.state.courseImplementation}
                                options={this.state.examOptions}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>

                        <Form.Field >
                            <label>Profesor </label>
                            <Form.Dropdown
                                clearable
                                placeholder="Odabir implementacije"
                                value={this.state.staff}
                                onChange={this.handleInputChange}
                                name="staff"
                                disabled={!this.state.exam}
                                options={this.state.staffOptions}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                        <Form.Field required error={this.state.markErr}>
                            <label>Ocjena </label>
                            <Form.Dropdown
                                clearable
                                placeholder="Odabir ocjene"
                                value={this.state.mark}
                                onChange={this.handleInputChange}
                                name="mark"
                                options={this.state.markOptions}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>


                    </Form.Group>
                    <Button
                        floated="right"
                        color="blue"
                        onClick={() => {
                            this.addGrade();
                        }}
                    >Ocijeni studenta </Button>
                    <br />
                    <br />
                </Form>

                <ToastContainer hideProgressBar />

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/ThirdCycle/Grades/Grades.js